import React from 'react';
import SidebarRow from './SidebarRow';
import SidebarSection, { CollapseBehavior } from './SidebarSection';
import SidebarSectionIcon from './SidebarSectionIcon';
import SidebarSectionOverflowMenuItems from './SidebarSectionOverflowMenuItems';
import { PremadeSections } from './SidebarSectionsProvider';
import useExternalPostPlatforms from './useExternalPostPlatforms';
import ExternalPostPlatformIcon from '../components/ExternalPostPlatformIcon';
import { externalDisplayName } from '../utils/post/externalPost';
import { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';

interface SidebarExternalPostsSectionProps {
  onMoveSectionUp?: () => void;
  onMoveSectionDown?: () => void;
  collapsible: boolean;
}

const SidebarExternalPostsSection = ({
  onMoveSectionUp,
  onMoveSectionDown,
  collapsible,
}: SidebarExternalPostsSectionProps) => {
  const platforms = useExternalPostPlatforms();
  const isMobile = useIsSize(Sizes.SM);

  if (platforms.length === 0) {
    return null;
  }

  return (
    <SidebarSection
      id="apps"
      icon={<SidebarSectionIcon section={{ id: 'integrations' }} />}
      title="Integrations"
      collapseBehavior={
        collapsible
          ? CollapseBehavior.InitiallyExpanded
          : CollapseBehavior.AlwaysExpanded
      }
      menuItems={
        !isMobile && (
          <SidebarSectionOverflowMenuItems
            selectedSectionId={PremadeSections.INTEGRATIONS}
            onMoveSectionUp={onMoveSectionUp}
            onMoveSectionDown={onMoveSectionDown}
          />
        )
      }
    >
      {platforms.map(
        ({ id }) =>
          id && (
            <SidebarRow
              key={id}
              to={`/integration-posts/${id}`}
              icon={<ExternalPostPlatformIcon id={id} size={12} />}
              subItem
            >
              {externalDisplayName(id)}
            </SidebarRow>
          ),
      )}
    </SidebarSection>
  );
};

export default SidebarExternalPostsSection;
